import React from 'react';
import { useTranslation } from 'react-i18next';

const Materials = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const materials = [
    {
      title: t('flooring'),
      desc: t('flooringDesc'),
      image: 'https://images.unsplash.com/photo-1694376329556-cf1ba3610960'
    },
    {
      title: t('wallCladding'),
      desc: t('claddingDesc'),
      image: 'https://images.unsplash.com/photo-1690049098415-29f96fca22c0'
    },
    {
      title: t('stairs'),
      desc: t('stairsDesc'),
      image: 'https://images.unsplash.com/photo-1627382385242-d41b912877eb'
    },
    {
      title: t('countertops'),
      desc: t('countertopsDesc'),
      image: 'https://images.unsplash.com/photo-1744025098626-66c0b9cb1ba8'
    },
    {
      title: t('waterjet'),
      desc: t('waterjetDesc'),
      image: 'https://images.pexels.com/photos/5052704/pexels-photo-5052704.jpeg'
    },
    {
      title: t('fireplaces'),
      desc: t('fireplacesDesc'),
      image: 'https://images.unsplash.com/photo-1652452083348-5c9611f8ada5'
    },
    {
      title: t('pools'),
      desc: t('poolsDesc'),
      image: 'https://images.pexels.com/photos/33685863/pexels-photo-33685863.jpeg'
    },
    {
      title: t('custom'),
      desc: t('customDesc'),
      image: 'https://images.unsplash.com/photo-1600421495550-158936f5ecfa'
    },
  ];

  return (
    <div className="pt-20">
      <section className="section-padding bg-[#F5F5F0]" data-testid="materials-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl text-center mx-auto">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-4">
              {t('materials')}
            </p>
            <h1 className={`text-5xl sm:text-6xl md:text-7xl font-light tracking-tighter leading-none mb-6 ${
              isRTL ? 'font-arabic' : 'font-heading'
            }`} data-testid="materials-title">
              {t('materialsTitle')}
            </h1>
            <p className={`text-xl text-gray-700 ${
              isRTL ? 'font-arabic' : ''
            }`}>
              {t('materialsSubtitle')}
            </p>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white" data-testid="materials-grid">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {materials.map((material, index) => (
              <div
                key={index}
                className="group overflow-hidden bg-white hover:shadow-lg transition-all duration-500"
                data-testid={`material-card-${index}`}
              >
                <div className="overflow-hidden h-64">
                  <img
                    src={material.image}
                    alt={material.title}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6 border border-t-0 border-black/5 group-hover:border-[#C4A661]">
                  <h3 className={`text-xl font-medium mb-2 ${
                    isRTL ? 'font-arabic' : 'font-heading'
                  }`}>
                    {material.title}
                  </h3>
                  <p className={`text-sm text-gray-600 leading-relaxed ${
                    isRTL ? 'font-arabic' : ''
                  }`}>
                    {material.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Materials;
